import cn from 'classnames';
import { GamesState } from 'features/eventPreMatch/interface/sportPrematch';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import CouponOverviewPanel from 'shared/components/CouponOverviewPanel';
import { betbuilderEvents, setDataLayer } from 'shared/constants/datalayer';
import { activePrimaryOverviewPanel } from 'shared/store/couponOverviewPanel.action';
import { OutcomesData } from 'shared/types/cms';
import { isMobile } from 'shared/util/utility';
import BetBuilderBasketFooter from '../BetBuilderBasketFooter';
import BetBuilderBasketHeader from '../BetBuilderBasketHeader';
import BetbuilderOverview from '../BetbuilderOverview';
import BetbuilderOverviewDesktop from '../BetbuilderOverviewDesktop';
import './styles.scss';

interface BetBuilderCreatorProps {
	totalOdds: number;
	selectedOddsArray: GamesState[];
	onClickRemoveGame: (elem: number) => void;
	clickOnCross: () => void;
	onAddBetToCoupon: () => void;
}

const BetBuilderCreator = ({ totalOdds, selectedOddsArray, onClickRemoveGame, clickOnCross, onAddBetToCoupon }: BetBuilderCreatorProps) => {
	const dispatch = useDispatch();
	const [isShowSelectedBets, setIsShowSelectedBets] = useState<boolean>(false);
	const [openDrawer, setOpenDrawer] = useState<boolean>(false);

	const handleClick = () => {
		setIsShowSelectedBets(!isShowSelectedBets);
		setOpenDrawer(!openDrawer);
	};

	const getSelectedOutcomeName = (item: GamesState) => {
		const index = item.outcomes.findIndex((outcome: OutcomesData) => outcome.outcomeId === item.outcomeId);
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return item.outcomes[index]!.outcomeName;
	};

	const handleBottomDrawer = () => {
		setIsShowSelectedBets(false);
		setOpenDrawer(false);
	};

	const RemoveAllBets = () => {
		handleBottomDrawer();
		clickOnCross();
	};
	const removeGame = (gameId: number) => {
		if (selectedOddsArray.length < 3) {
			handleBottomDrawer();
		}
		onClickRemoveGame(gameId);
	};
	const onAddBetbuilderCouponInMobile = () => {
		onAddBetToCoupon();
		handleBottomDrawer();
	};

	const isMoreThenOneBetbuilderEvent = selectedOddsArray.length > 1;

	useEffect(() => setDataLayer([betbuilderEvents.DATALAYER_BETBUILDER_TEST_NEW]), []);

	useEffect(() => {
		dispatch(activePrimaryOverviewPanel(!selectedOddsArray.length));

		return () => {
			dispatch(activePrimaryOverviewPanel(true));
		};
	}, [selectedOddsArray.length]);

	return (
		<div className="BetBuilderCreator">
			{isMobile() && (
				<>
					<CouponOverviewPanel type="secondary" numOfSlipsInBetslip={selectedOddsArray.length}>
						<div className={cn('BetBuilderCreator__content', { BetBuilderCreator__disableHeaderClick: selectedOddsArray.length <= 1 })}>
							<BetBuilderBasketHeader
								totalOdds={totalOdds}
								selectedOddsArray={selectedOddsArray}
								handleClick={handleClick}
								isShowSelectedBets={isShowSelectedBets}
								clickOnCross={RemoveAllBets}
								isMoreThenOneBetbuilderEvent={isMoreThenOneBetbuilderEvent}
							/>
							<BetBuilderBasketFooter
								totalOdds={totalOdds}
								onAddBetToCoupon={onAddBetToCoupon}
								isMoreThenOneBetbuilderEvent={isMoreThenOneBetbuilderEvent}
							/>
						</div>
					</CouponOverviewPanel>
					<BetbuilderOverview
						onAddBetToCoupon={onAddBetbuilderCouponInMobile}
						totalOdds={totalOdds}
						isShowSelectedBets={isShowSelectedBets}
						handleClick={handleClick}
						selectedOddsArray={selectedOddsArray}
						getSelectedOutcomeName={getSelectedOutcomeName}
						onClickRemoveGame={(gameId) => removeGame(gameId)}
						clickOnCross={RemoveAllBets}
						openDrawer={openDrawer}
						isMoreThenOneBetbuilderEvent={isMoreThenOneBetbuilderEvent}
						handleBottomDrawer={handleBottomDrawer}
					/>
				</>
			)}
			{!isMobile() && selectedOddsArray.length > 0 && (
				<BetbuilderOverviewDesktop
					onAddBetToCoupon={onAddBetToCoupon}
					totalOdds={totalOdds}
					isShowSelectedBets={isShowSelectedBets}
					handleClick={handleClick}
					selectedOddsArray={selectedOddsArray}
					getSelectedOutcomeName={getSelectedOutcomeName}
					onClickRemoveGame={onClickRemoveGame}
					clickOnCross={clickOnCross}
				/>
			)}
		</div>
	);
};

export default BetBuilderCreator;
